import { isBrowser } from './environment'

let PCLN_DATA = (() => {
  let pclnData = {}

  if (isBrowser()) {
    pclnData = window.PCLN_BOOTSTRAP_DATA || window.requestHandlerData || {}
  } else {
    pclnData = {
      appName: '',
      appVersion: '-.-.-',
      node: true,
    }
  }
  return pclnData
})()

export default function () {
  return { ...PCLN_DATA }
}

export function updatePCLNData(data) {
  if (typeof data !== 'object') return
  PCLN_DATA = { ...PCLN_DATA, ...data }
}
